export const name = '@lifi/widget'
export const version = '3.30.0'
